import { convertToRupiah } from '../../../helper/Rupiah'

const ContractorTableItem = (props) => {
  const data = props.data

  return (
    <tr>
      <td>{props.no}</td>
      <td>{data.project_id}</td>
      <td>Contractor</td>
      <td>{data.client_name}</td>
      <td>{data.tgl_deposit}</td>
      <td>{data.start_date}</td>
      <td>Rp. {convertToRupiah(data.deposit)}</td>
      <td>{data.payment_method}</td>
      <td>{data.payment_channel}</td>
      <td>Rp. {convertToRupiah(data.fee_transfer)}</td>
    </tr>
  )
}

export default ContractorTableItem
